/** Modulo Responsavel (40) — codigos em contracts/enums.yaml */
export const RESPONSAVEL_ACAO = {
  CRIAR: 401,
  ATUALIZAR: 402,
  REMOVER: 403,
} as const;

export const RESPONSAVEL_ACOES_MODULO = [
  RESPONSAVEL_ACAO.CRIAR,
  RESPONSAVEL_ACAO.ATUALIZAR,
  RESPONSAVEL_ACAO.REMOVER,
] as const;
